// extracted by mini-css-extract-plugin
export default {"signalIcon":"iTMOCpR0droR8iD9DwlQ__signalIcon___","saveSignalBtn":"VTexrprrqQNtnaDHw2cQ__saveSignalBtn___","viewSigSettings":"g3NmOkId7MDuSUl4ebbP__viewSigSettings___"};